import { render, staticRenderFns } from "./KeyFinanceRatioPdf.vue?vue&type=template&id=48ac98ba&scoped=true"
import script from "./KeyFinanceRatioPdf.vue?vue&type=script&lang=js"
export * from "./KeyFinanceRatioPdf.vue?vue&type=script&lang=js"
import style0 from "./KeyFinanceRatioPdf.vue?vue&type=style&index=0&id=48ac98ba&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ac98ba",
  null
  
)

export default component.exports